import { Component, OnInit } from "@angular/core";
import { DataService } from "../../shared/dataService";
import { IProduct } from "../../shared/product";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
    selector: "product-list",
    templateUrl: "productList.component.html",
    styleUrls: ["productList.component.css"]
})
export class ProductList implements  OnInit{
    public products: IProduct[] = [];

    constructor(private route: ActivatedRoute, private router: Router, private data: DataService) {
        console.log(this.route.snapshot.paramMap.get('productTypeId'));
    }

    ngOnInit(): void {

        var idGuid = this.route.snapshot.paramMap.get('productTypeId');

        this.data.loadProductsByType(idGuid)
            .subscribe(success => {
                if (success) {
                    this.products = this.data.products;
                }
            });
    }

    addProduct(product: IProduct) {
        this.data.addToOrder(product);
    }
}